module.exports = __webpack_public_path__ + "img/dots_green.1379d9e8.png";